module.exports = __webpack_public_path__ + "static/media/backendIcon.4aec0fe1.svg";